module.exports = __webpack_public_path__ + "static/media/research_bg.d72dfadb.jpg";